module.exports = __webpack_public_path__ + "static/media/4.49e080ea.svg";